module.exports = __webpack_public_path__ + "static/media/MHRP09N0008.1e8667ea.svg";